import { Injectable } from '@angular/core';
import { ModelService } from '../services/model.service';
import { MinisService } from '../services/minis.service';
import { ProjectData } from '../entities/project-data.entity';
import { Observable } from 'rxjs';
import { ConfigService } from '../app.config';
import { BearerHttpService } from '../services/bearer-http.service';
import { map } from 'rxjs/operators';
import { Utils } from '../utils.module';

@Injectable({
	providedIn: 'root'
})
export class BuilderService {

	constructor(
		private http: BearerHttpService,
		private modelService: ModelService,
		private minisService: MinisService
	) { }

	/** Merry Christmas: unicamente guarda el proyecto */
	// SALVAR PROYECTO
	public saveProject(projectData: ProjectData): Observable<any> {
		// Si no tiene fecha asignar la actual (esto no se debería cumplir).
		if (!projectData.fechaCreacion) projectData.fechaCreacion = new Date();

		// Limpiar espacios y en su defecto poner nombre por defecto.
		if (projectData.nombre) projectData.nombre = projectData.nombre.trim();	else { projectData.nombre = ''; }

		// Comprobar si hay proyecto en el localStorage.
		let temp: any = localStorage.getItem(Utils.CURRENT_PROJECT);
		if (temp) {
			const p = JSON.parse(temp);
			temp = (p.nombre && p.nombre !== '') ? p.nombre.trim() : '';
		}

		// Tiene preferencia el local storage.
		if (temp !== '') {
			projectData.nombre = temp;
		}
		else if (projectData.nombre === '') { // !!!!!!!!!!!! DOM
			//const np = window.document.getElementById('NOMBR EPROYECTO');
			//projectData.nombre = (np) ? np.textContent.trim() : '';
			projectData.nombre = Utils.DOMWebHeader_getTitleProject();
		} // !!!!!!!!!!!! DOM

		// Actulizar la miníatura si es necesario.
		this.minisService.updateMini(projectData); // TODO segundo parámetro optativo, con las coordenadas antiguas.

		return this.http.Post(ConfigService.REST_SERVER + '/api/configProyecto', {
			configuracion: JSON.stringify(projectData), //Utils.clearSVGinfoProject(projectData)),
			id: projectData._id
		}).pipe(map((response: Response) => { return response; }));
	}

	
	/** Genera el presupuesto y guarda el proyecto. */
	public budget(projectData: ProjectData): Observable<any> {
		// Pass currentLanguage to budget (ignore language in projectData to avoid modifying and saving changes)
		var userLang = this.modelService.getLanguage().currentLanguage;

		return this.http.Post(ConfigService.REST_SERVER + '/api/budget', { configuracion: JSON.stringify(projectData), id: projectData._id, lang: userLang })
			.pipe(map((response: Response) => {
				console.log("RESPUESTA", response)
				//projectData._id = response.json();
				return response;
			}));
	}

	public uploadProjectImage(id: String, file: string): Observable<any> {
		return this.http.Post(ConfigService.REST_SERVER + '/api/upload/project/' + id, { img: file, id: id })
			.pipe(map(res => { this.modelService.getUser().userUpdatedSignal.emit(true); }));
	}
}

	// ADQUIRIR PROYECTO
	//public getProject(idProyecto: string): Observable<any> {
	//	return this.http.Get(ConfigService.REST_SERVER + '/api/ configProyecto/' + idProyecto).pipe(map((response: Response) => { return response; }));
	//}